// Generated by ReScript, PLEASE EDIT WITH CARE


function execute(country) {
  switch (country.TAG | 0) {
    case /* INR */0 :
        return {
                TAG: /* India */1,
                _0: {
                  time_zone: country.timezone,
                  currency: country.currency,
                  iso_code: country.iso_code,
                  mobile_validation_regex: country.mobile_validation_regex
                }
              };
    case /* AED */1 :
        return {
                TAG: /* UAE */0,
                _0: {
                  time_zone: country.timezone,
                  currency: country.currency,
                  iso_code: country.iso_code,
                  mobile_validation_regex: country.mobile_validation_regex
                }
              };
    case /* BDT */2 :
        return {
                TAG: /* BD */2,
                _0: {
                  time_zone: country.timezone,
                  currency: country.currency,
                  iso_code: country.iso_code,
                  mobile_validation_regex: country.mobile_validation_regex
                }
              };
    case /* TRY */3 :
        return {
                TAG: /* TR */3,
                _0: {
                  time_zone: country.timezone,
                  currency: country.currency,
                  iso_code: country.iso_code,
                  mobile_validation_regex: country.mobile_validation_regex
                }
              };
    case /* MYR */4 :
        return {
                TAG: /* MY */4,
                _0: {
                  time_zone: country.timezone,
                  currency: country.currency,
                  iso_code: country.iso_code,
                  mobile_validation_regex: country.mobile_validation_regex
                }
              };
    
  }
}

export {
  execute ,
  
}
/* No side effect */
